import * as React from 'react';
import * as styles from '../styles.module.less';

// import FooterLinkList from './footer-link-list';
import { FooterLinkList } from './footer-link-list-new';
import { FooterSecurityInfo } from './footer-security-info';
import { FooterBanner } from './footer-banner';

interface IProps {
  isMediaTool: boolean;
  isNewLayout?: boolean;
}

const Component: React.FC<IProps> = ({ isMediaTool }) => {
  return (
    <>
      <div className={`${styles.footer_container}`}>
        {/* <div className="container-new footer-header w-container" /> */}
        {/* <FooterLinkList isNewLayout={isNewLayout} isMediaTool={isMediaTool} /> */}
        <FooterLinkList />
        <FooterSecurityInfo />
      </div>
      <FooterBanner isMediaTool={isMediaTool} />
    </>
  );
};

export default Component;
